import { htmlSafe } from '@ember/template';
import { isEmpty } from '@ember/utils';
import Component from '@glimmer/component';
import { or } from 'ember-truth-helpers';

import type { TooltipOptions } from '../../../../types/components/prism/data-bar.ts';
import {
  COLOR_TEXT_SUBDUED,
  getCssVariableValue,
} from '../../../../utils/css-variable.ts';
import PrismIcon from '../../icon.gts';
import PrismTooltip from '../../tooltip.gts';

interface PrismDataBarBlocksDataBarLabelSignature {
  Args: {
    color?: string;
    text?: string;
    tooltip?: TooltipOptions;
  };
  Blocks: {
    default: [];
  };
}

export default class PrismDataBarBlocksDataBarLabel extends Component<PrismDataBarBlocksDataBarLabelSignature> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get colorStyle() {
    const color = this.args.color ?? getCssVariableValue(COLOR_TEXT_SUBDUED);
    return htmlSafe(`color: ${color}`);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get showTooltip() {
    return !isEmpty(this.args.tooltip?.message);
  }

  <template>
    {{#if (has-block)}}
      <div class="data-bar-label">
        {{yield}}
      </div>
    {{else}}
      <div class="text-200--regular data-bar-label" style={{this.colorStyle}}>
        <p class="truncate">{{@text}}</p>
        {{#if this.showTooltip}}
          <div class="data-bar-label__tooltip">
            <PrismIcon
              @color={{@tooltip.color}}
              @name="circle-information-outline"
              @size={{or @tooltip.iconSize "small"}}
            />
            <PrismTooltip
              @side={{@tooltip.side}}
              @text={{or @tooltip.message ""}}
              @title={{@tooltip.title}}
            />
          </div>
        {{/if}}
      </div>
    {{/if}}
  </template>
}
